import { ExitToAppOutlined, LockOutlined, Person } from "@mui/icons-material";
import { Divider, ListItemText, MenuItem, Tooltip } from "@mui/material";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { signoutUser } from "../../../actions/login";
import { StyledHeader } from "../../styled/layout";
import ChangePasswordDialog from "../setPassword/changePasswordDialog";

const IconUser = () => {
  const dispatch = useDispatch();

  const [openMenu, setOpenMenu] = React.useState(null);
  const [openChangePassword, setOpenChangePassword] = React.useState(false);

  const handleClose = () => {
    setOpenMenu(null);
    setOpenChangePassword(false);
  };

  const handleSignout = () => {
    dispatch(signoutUser());
  };

  const handleClickChangePassword = () => {
    setOpenMenu(null);
    setOpenChangePassword(true);
  };

  const handleClickMenu = (event) => {
    setOpenMenu(event.currentTarget);
  };

  const userName = useSelector((state) => state.auth.userName);

  return (
    <React.Fragment>
      <StyledHeader.OptionsIconContainer>
        <Tooltip title="Perfil" arrow>
          <StyledHeader.HeaderIcon size="small" onClick={handleClickMenu}>
            <Person />
          </StyledHeader.HeaderIcon>
        </Tooltip>
      </StyledHeader.OptionsIconContainer>
      <StyledHeader.Menu
        id="simple-menu"
        anchorEl={openMenu}
        keepMounted
        open={Boolean(openMenu)}
        onClose={handleClose}>
        <MenuItem
          disabled
          sx={{
            fontSize: "small",
          }}>
          {userName}
        </MenuItem>
        <MenuItem onClick={handleClickChangePassword}>
          <StyledHeader.MenuItem size="small">
            <LockOutlined />
          </StyledHeader.MenuItem>
          <ListItemText primary="Cambiar contraseña" />
        </MenuItem>
        <Divider variant="middle" />
        <MenuItem onClick={handleSignout}>
          <StyledHeader.MenuItem size="small">
            <ExitToAppOutlined />
          </StyledHeader.MenuItem>
          <ListItemText primary="Cerrar sesión" />
        </MenuItem>
      </StyledHeader.Menu>
      <ChangePasswordDialog open={openChangePassword} onClose={handleClose} />
    </React.Fragment>
  );
};

export default IconUser;
